/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as commodityGroupActions from "../graphql/actions/commodityGroup";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as commoditiesAction from "./commodity";

export function add(commodityGroup) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(commodityGroup));
        commodityGroupActions.add(
            function (response) {
                dispatch(saved(response.data.createCommodityGroup));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCommodityGroup(response.data.createCommodityGroup));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            commodityGroup
        );
    };
}

export function edit(commodityGroup) {
    let id = commodityGroup.id;
    delete commodityGroup.id;
    delete commodityGroup.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(commodityGroup));
        commodityGroupActions.edit(
            function (response) {
                dispatch(saved(response.data.editCommodityGroup));
                dispatch(fetchCommodityGroups(true));
                dispatch(commoditiesAction.fetchCommodities(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            commodityGroup
        );
    };
}


export function fetchCommodityGroups(force = false) {
    return dispatch => {
        dispatch(loading());
        commodityGroupActions.getCommodityGroups(
            function (response) {
                dispatch(receiveCommodityGroups(response.data.commodityGroups));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    };
}


export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        commodityGroupActions.get(
            function (response) {
                dispatch(receiveCommodityGroup(response.data.commodityGroup));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}




export function loading() {
    return {
        type: types.LOADING_COMMODITY_GROUP
    };
}

export function saving(commodityGroup) {
    return {
        type: types.SAVING_COMMODITY_GROUP,
        payload: commodityGroup
    };
}

export function saved(commodityGroup) {
    return {
        type: types.SAVED_COMMODITY_GROUP,
        payload: commodityGroup
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_COMMODITY_GROUP,
    };
}

export function receiveCommodityGroups(data) {
    return {
        type: types.RECEIVED_COMMODITY_GROUPS,
        payload: data
    };
}


export function receiveCommodityGroup(data) {
    return {
        type: types.RECEIVED_COMMODITY_GROUP,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/commodityGroup.js